<template lang="pug">
div
  iframe(name='iframe_q' style='display:none;')
  v-navigation-drawer(app right disable-route-watcher max-width='600' v-model='show_sidebar')
    v-container
      v-row
        v-col
          span {{journal_name}}
      v-row
        v-col
          v-btn(v-if="isadmin" @click="export_results") {{$t("s.download")}}
          v-btn-toggle(v-if="layout == 'masonry'" v-model='layout_' mandatory dense)
            v-tip-icon-btn(mdi='view-list' :tip='$t("s.list")' value='list')
            v-tip-icon-btn(mdi='image-text' :tip='$t("s.block")' value='masonry')
          v-list(v-show='hits_total' dense)
            v-list-item-group(mandatory v-model='filters_applied')
              //- ANCHOR <v-subheader>約有{{ hits_total }}項結果，目前顯示前{{ hits.length }}項</v-subheader>
              //- span.text-subtitle-2
                | {{$tc("s.total_results", hits_total)}}{{ $tc("s.showing_first_n", hits.length) }}
              span.text-subtitle-2
                | {{$tc("s.total_results", hits_total)}}{{ $tc(`s.showing_first_n_${sort}`, hits.length) }}
              v-list-item(:value='0')
                v-list-item-content
                  span.text-subtitle-2 {{ $t("s.current_showing") }}({{hits.length}})
              template(v-for='(ff, ff_k) in filters')
                template(v-if='ff.items.length')
                  v-subheader(:key='ff_k')
                    v-btn(@click='toggle_filter_level(ff)' icon)
                      v-icon(v-if='next_filter_level(ff)==1') mdi-dots-horizontal
                      v-icon(v-else-if='next_filter_level(ff)==2') mdi-minus-circle-outline
                      v-icon(v-else) mdi-plus-circle-outline
                    span {{ $t(ff.title )}}({{ ff.items.length }})
                  template(v-for='(v, k) in ff.items')
                    v-list-item(v-if='(ff.showless == 0) || (ff.showless == 1 && v[1].length > 1)' :key="'ff_' + String(ff_k) + '_' + String(k)" :value='v[1]')
                      v-list-item-content
                        span.text-subtitle-2(v-html='`${v[0]}(${v[1].length})`')
  v-container(style='max-width: 1200px; min-width: 600px; align-content: start; justify-content: center;')
    v-row
      //- ANCHOR SearchBar
      v-col
        search-bar(:mainset_id='mainset_id' :uniname='uniname' :q='q' :batch='batch' :layout='layout' :from-year='fromYear' :from-month='fromMonth' :to-year='toYear' :to-month='toMonth' :setsn='setsn' :sort='sort' :fields='fields' @on-resend='search_by_q_param(q_params)')
    masonry-artis(v-if="layout_=='masonry'" :items='hits_to_show' :q='q')
    v-row(v-else)
      v-col
        v-skeleton-loader.ma-1(max-width='800' type='article' transition='scale-transition' :loading='loading_hits')
          div
            v-card.ma-1
              v-row
              v-row
                v-expansion-panels(hover inset dense)
                  v-expansion-panel(v-for='(v, i1) in hits_to_show' :key="'k-' + i1")
                    v-expansion-panel-header
                      template(v-slot:default='pp')
                        v-container
                          v-row
                            router-link.indigo--text.text-body-1(target='_blank' :to='to_artiview(v, q)' v-html='v.title')
                            span(v-if='test')
                              | [{{v._rank}}]::{{v._score}}
                          template(v-if='!pp.open')
                            v-row(v-for='(vv, i2) in v.highlights.slice(0, 2)' :key="'kh-' + i1 + '-' + i2")
                              span.text-subtitle-2.text-truncate(v-html='vv')
                    v-expansion-panel-content
                      v-list(dense two-line)
                        v-list-item
                          v-list-item-content
                            v-list-item-subtitle {{$t("preview")}}
                            span.text-subtitle-2(v-for='(vv, i2) in v.highlights' :key="'kcl-' + i1 + '-' + i2" v-html='vv')
                        v-divider
                        v-hover(v-for='({idx, value}, n) in result_contents(v)' :key='`rs_detail_${v.metano}_${n}`' v-slot='{hover}' :close-delay='50')
                          v-list-item
                            v-list-item-content
                              //- <v-list-item-subtitle>{{idx}}-{{$t(idx)}}{{subtitle}}</v-list-item-subtitle>
                              v-list-item-subtitle {{$t(idx)}}
                              span(v-html='value')
                              span.mt-1(v-if="idx=='title' && v.title2 && v.title2 !== v.title" v-html='v.title2')
                            v-list-item-action(v-show='hover')
                              open-in-journal(:item='v' :idx='idx')
    v-skeleton-loader.ma-1(v-if='show_load_more' type='article' :loading='loading_more')
      v-row(justify='center')
        v-btn(@click='load_more' v-intersect='on_load_more_intersect')
          v-icon mdi-chevron-down
          |           {{ $t("s.load_more") }}
</template>
<script>
// import _ from "lodash"
import {debug} from 'loglevel'
import { numberWithCommas, pubtime_str } from "@/api/util"
import OpenInJournal from "@/components/OpenInJournal"
import MasonryArtis from "@/components/MasonryArtis"
import VTipIconBtn from "@/components/VTipIconBtn"
import SearchBar from "@/components/SearchBar"
import {commit_message} from "@/api/states"

import {
  // search_journal,
  // search_collection,
  // search_all,
  get_toc_name,
} from "@/api"
import {onDownloadComplete, onDownloadProgress} from "@/api/sys_notify"
import {qq, qq_export} from "@/api/prodapi"
const FileDownload = require('js-file-download');

function search_to_hits(rs) {
  var hits = []
  for (var i = 0; i < rs.hits.hits.length; i++) {
    const v = rs.hits.hits[i]
    const metano = v._source.metano
    const _rank = i + 1
    const _score = v._score
    const uniname = metano.slice(0, 3).toLowerCase()
    const journal = uniname
    const journal_name = get_toc_name(uniname)
    let content = v._source.content
    const volno = v._source.volno
    const pubtime = v._source.pubtime ? pubtime_str(v._source.pubtime) : undefined
    const pubyear = pubtime ? pubtime.slice(0, 5) : undefined
    const dynasty = v._source.dynasty
    const sourcesdes = v._source.sourcesdes
    const word = v._source.word
    const images = v._source.images
    const hits_field = {}
    const hits_kw = {}
    const highlit_keys = ["content", "title", "title2", "authors", "keyword", "keyword2", "column", "sourcesdes"]
    if(['wai', 'diw'].includes(uniname)) {
      // const fixWordGif = (ii) => ii ? ii.replaceAll('[wgif]', '<img src="/images/wordgif/').replaceAll('[/wgif', '" border="0" />') : ii
      const fixWordGif = (ii) => ii ? ii.replace(/\[wgif\]/g, '<img src="/images/wordgif/').replace(/\[\/wgif/g, '" border="0" />') : ii
      title = fixWordGif(title)
      content = fixWordGif(content)
    }
    if(v.matched_queries) {
      for(let i = 0; i < v.matched_queries.length; i++) {
        const _ = v.matched_queries[i]
        const [fld, kw] = _.split('::')
        hits_field[fld] = true
        hits_kw[kw] = true
        // debug('k', _, k)
      }
    }
    var highlights = []
    if(v.highlight) {
      highlit_keys.forEach((k)=>{
      // for(const k in v.highlight) {
          if (v.highlight[k]) {
          for(let i = 0; i < v.highlight[k].length; i++) {
            // let hilit = v.highlight[k][i].replaceAll('[/hilit][hilit]', '').replaceAll('[/hilit]', '</span>')
            // hilit = hilit.replaceAll('[hilit]', '<span class="hilit">')
            let hilit = v.highlight[k][i].replace(/\[\/hilit\]\[hilit\]/g, '').replace(/\[\/hilit\]/g, '</span>')
            hilit = hilit.replace(/\[hilit\]/g, '<span class="hilit">')
            if(['authors', 'title', 'title2', 'keyword', 'keyword2', 'column'].includes(k)) {
              // debug(v.highlight[k][i], hilit)
              v._source[k] = hilit
            }
            else {
              highlights = highlights.concat(hilit)
            }
          }
          // hits_field[k] = true
        }
      })
    }
    highlights = [...new Set(highlights)]
    let title = v._source.title
    const title2 = (v._source.title != v._source.title2) ? v._source.title2 : undefined
    const authors = v._source.authors
    const d_ = {
      uniname,
      metano,
      title,
      title2,
      authors,
      journal,
      journal_name,
      dynasty,
      sourcesdes,
      highlights,
      volno,
      pubtime,
      pubyear,
      word,
      hits_field,
      hits_kw,
      images,
      content,
      _rank,
      _score,
    }
    const d = Object.assign({}, v._source, d_)
    for(const k in d) {
      if(d[k] === undefined) delete d[k]
    }
    hits.push(d)
  }
  return hits
}

import { ref, computed } from '@vue/composition-api'
import store from '@/store'

export default {
  name: 'SearchView',
  components: {
    OpenInJournal,
    MasonryArtis,
    VTipIconBtn,
    SearchBar,
  },
  emits: [],
  props: {
    mainset_id: {},
    uniname: {},
    q: {},
    batch: {
      type: Number,
      default: 20,
    },
    layout: {
      default: 'list',  // list, masonry
    },
    fromYear: Number,
    fromMonth: Number,
    toYear: Number,
    toMonth: Number,
    setsn: Array,
    fields: Array,
    sort: {
      type: String,
      default: 'relevant',
    },
  },
  setup(props, {emit}) {
    const export_results = function() {
      const {q} = this.q_params
      const setsn = this.uniname ? Array(this.uniname)
        : this.mainset_id ? Array(this.mainset_id)
        : Object.assign([], this.setsn)
      const fields = Object.assign([], this.fields)
      const fromYear = this.fromYear
      const toYear = this.toYear
      const fromMonth = fromYear ? this.fromMonth : undefined
      const toMonth = toYear ? this.toMonth : undefined
      const sort = this.sort
      const opts = {fromYear, fromMonth, toYear, toMonth, setsn, fields, sort, onDownloadProgress, onDownloadComplete}
      for(let k in opts) {
        if(!opts[k]) delete opts[k]
      }
      debug('opts', opts)
      const pp = qq_export(q, opts)
      return pp.then((resp)=>{
        debug('qq_export', typeof resp)
        FileDownload(resp, 'search_results.xlsx')
      })
    }
    const isadmin = ref(store.state.isadmin)
    return {
      isadmin,
      export_results,
    }
  },
  created() {
    this.$store.subscribe((mutation)=>{
      if(mutation.type == 'toggle_context_sidebar') {
        this.show_sidebar = !this.show_sidebar
      }
      else if(mutation.type == 'set_test') {
        this.test = mutation.payload
      }
    })
  },
  methods: {
    on_load_more_intersect(entries, observer) {
      // const isIntersecting = entries[0].isIntersecting
      // if(this.test && isIntersecting) {
      //   this.load_more()
      // }
    },
    build_filters(hits) {
      hits = Object.assign({}, hits)
      let cols = {}
      const hits_field = {}, hits_kw = {}
      for(const i in hits) {
        const hit = hits[i]
        for(let kcol in hit) {
          if(!hit[kcol]) continue
          if(!(kcol in this.$mm)) continue
          if(!cols[kcol]) cols[kcol] = {}
          const v = hit[kcol]
          if(!(v in cols[kcol])) cols[kcol][v] = []
          cols[kcol][v].push(hit.metano)
        }
        for(const fld in hit.hits_field) {
          const kkn = this.$t(fld)  // $mm[fld]
          if(!hits_field[kkn]) {
            hits_field[kkn] = Array()
          }
          hits_field[kkn].push(hit.metano)
        }
    
        const kws = new Set()
        for(const kw in hit.hits_kw) {
          kws.add(kw)
        }
        const kw_ = [...kws].sort().join('+')
        if(!hits_kw[kw_]) {
          hits_kw[kw_] = Array()
        }
        hits_kw[kw_].push(hit.metano)
      }
      // debug('hits_kw', hits_kw)
      const cmp = (a, b) => {
        if(b[1].length > a[1].length)
          return 1
        else if(b[1].length < a[1].length)
          return -1
        if(b[0] > a[0])
          return 1
        else if(b[0] < a[0])
          return -1
        return 0
      }
      cols = Object.assign({}, cols, {hits: hits_field, kw: hits_kw})
      const col_items = {}
      for(const k in cols) {
        col_items[k] = Array()
        for(const kk in cols[k]) {
          col_items[k].push([kk, cols[k][kk]])
        }
        col_items[k] = col_items[k].sort(cmp)
      }
      // this.filters.hits.items = hits_field
      debug('col_items', col_items)
      return col_items
    },
    result_contents(v) {
      const
      {
        journal_name,
        title,
        authors,
        keyword,
        keyword2,
        column,
        pubtime,
        volno,
        dynasty,
        sourcesdes,
      } = this.$mm
      const mapping_ =
      {
        journal_name,
        title,
        authors,
        keyword,
        keyword2,
        column,
        pubtime,
        volno,
        dynasty,
        sourcesdes,
      }      
      const uniname = v.metano.slice(0, 3)
      if(['wai'].includes(uniname)) {
        delete mapping_.volno
      }
      let rr = []
      for(const idx in mapping_) {
        if(!v[idx]) continue
        const subtitle = mapping_[idx]
        const value = v[idx]
        rr.push({idx, subtitle, value})
      }
      // debug('result_contents', rr, v)
      return rr
    },
    to_artiview(v, q) {
      const uniname = v.metano.slice(0, 3)
      const metaNo = v.metano
      const to = {
        name: 'ArtiView',
        params: {uniname, metaNo},
        query: this.$q({q}),
      }
      return to
    },
    next_filter_level(ff) {
      if(ff.two_level) {
        return (ff.showless == 2) ? 0 : 2
      }
      else {
        return (ff.showless+1) % 3
      }
    },
    toggle_filter_level(ff) {
      ff.showless = this.next_filter_level(ff)
    },
    reset_search() {
      this.show_load_more = this.loading_more = this.hits_total = false
      this.current_q = null
      this.loading_hits = true
      this.hits = Array()
    },
    search_by_q_param(q_params) {
      const {q, batch=20, layout} = q_params
      debug('watch::q_params', q, batch, q_params)
      this.layout_ = layout
      this.do_search(q, 0, batch)
    },
    do_search(q, load_from, batch) {
      debug('q', q, load_from, batch)
      if (!q) return
      if(load_from == 0) this.reset_search()
      const setsn = this.uniname ? Array(this.uniname)
        : this.mainset_id ? Array(this.mainset_id)
        : Object.assign([], this.setsn)
      const fields = Object.assign([], this.fields)
      const fromYear = this.fromYear
      const toYear = this.toYear
      const fromMonth = fromYear ? this.fromMonth : undefined
      const toMonth = toYear ? this.toMonth : undefined
      const sort = this.sort
      const opts = {fromYear, fromMonth, toYear, toMonth, setsn, fields, sort, onDownloadProgress, onDownloadComplete}
      for(let k in opts) {
        if(!opts[k]) delete opts[k]
      }
      debug('opts', opts)
      const pp = qq(q, load_from, batch, opts)
      return pp.then((rs) => {
        const hits = search_to_hits(rs)
        this.hits = this.hits.concat(hits)
        if(this.hits_total === false) {
          this.hits_total = numberWithCommas(rs.hits.total.value)
        }
        this.show_load_more = hits.length >= batch
        if(rs.q !== q) {
          // debug('*** q convered ***', q, '==>', rs.q)
          let msg = this.$t("s.conv", {q: q, qt: rs.q})
          debug('*** q convered ***', msg)
          commit_message(msg)
        }
      })
      .finally(() => {
        this.loading_hits = false;
        if(this.hits.length == 0) {
          // debug('error', '沒有搜尋結果')
          this.$store.commit('error', this.$t('no_search_results'))
        }
      })
    },
    load_more() {
      const q = this.q
      const batch = this.batch
      const load_from = this.hits.length
      const that = this
      that.loading_more = true
      return this.do_search(q, load_from, batch).finally(()=>{
        that.loading_more = false
      })
    },
  },
  watch: {
    uniname: {
      handler(v) {
        if(v) {
          this.$store.commit('set_uniname', v)
          this.journal_name = this.$store.state.journal_name
          this.mainset_name = this.$store.state.mainset_name
        }
      },
      immediate: true,
    },
    mainset_id: {
      handler(v) {
        if(v) {
          this.$store.commit('set_mainset', v)
          this.mainset_name = this.$store.state.mainset_name
        }
      },
      immediate: true,
    },
    q_params: {
      handler(q_params) {
        this.search_by_q_param(q_params)
      },
      immediate: true,
    },
    hits(hits) {
      // debug('hits', hits.length)
      const filter_items = this.build_filters(hits)
      for(const k in this.filters) {
        // debug('kk', k, filter_items)
        if(filter_items && filter_items[k]) {
          this.filters[k].items = filter_items[k]
        }
        else {
          this.filters[k].items = []
        }
      }
    },
  },
  computed: {
    q_params() {
      const q = this.q
      const mainset_id = this.mainset_id
      const uniname = this.uniname
      const batch = this.batch
      const layout = this.layout
      const fromYear = this.fromYear
      const fromMonth = this.fromMonth
      const toYear = this.toYear
      const toMonth = this.toMonth
      const setsn = this.setsn
      const fields = this.fields
      return {
        q, batch, mainset_id, uniname, layout,
        fromYear, fromMonth, toYear, toMonth,
        setsn, fields,
      }
    },
    q_hint() {
      if(this.uniname) {
        return "搜尋本期刊內容"
      }
      else {
        return "搜尋本庫內容"
      }
    },
    hits_to_show() {
      if(this.filters_applied == 0)
        return this.hits
      var hits_ = []
      for(var i=0; i < this.hits.length; i++) {
        var v = this.hits[i]
        if(this.filters_applied.includes(v.metano))
          hits_.push(v)
      }
      // debug('on hits_to_show', hits_)
      return hits_
    }
  },
  data() {
    const filters = {
      journal_name: {
        title: 'pc.journal',
        showless: 2,  // 0:all 1:less(no less then 2) 2:none
        two_level: true,
        items: [],
      },
      sourcesdes: {
        title: 'sourcesdes',
        showless: 2,  // 0:all 1:less(no less then 2) 2:none
        two_level: true,
        items: [],
      },
      pubtime: {
        title: 'pubtime',
        showless: 2,  // 0:all 1:less(no less then 2) 2:none
        two_level: true,
        items: [],
      },
      authors: {
        title: 'authors',
        showless: 2,
        two_level: true,
        items: [],
      },
      dynasty: {
        title: 'dynasty',
        showless: 2,
        two_level: true,
        items: [],
      },
      word: {
        title: 'word',
        showless: 2,
        two_level: true,
        items: [],
      },
      hits: {
        title: 'fields',
        showless: 2,
        two_level: true,
        items: [],
      },
      kw: {
        title: 'pc.kw',
        showless: 2,
        two_level: true,
        items: [],
      },
    }
    const layout_ = this.layout
    const test = this.$store.state.test
    return {
      journal_name: undefined,
      mainset_name: undefined,
      show_sidebar: true,
      show_load_more: false,
      hits_total: false,
      loading_hits: false,
      hits: [],
      loading_more: false,
      filters_applied: 0,
      filters,
      layout_,
      test,
    }
  },
}
</script>
<style>
.hilit {
  color:#f44336;
  caret-color: #f44336;
}
</style>

